import React from 'react';
import PropTypes from 'prop-types';
import { FDDialogTitle } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('AccountPerformanceDashboard', () => ({
  root: {
    position: 'absolute',
    width: '20px',
    height: '20px',
    background: 'white',
    right: '20px',
    top: '20px',
  },
}));

export const DialogTitle = ({ value, preventModalClose, ...rest }) => {
  const classes = useStyles();
  return (
    <>
      {preventModalClose ? <div className={classes.root} /> : null}
      <FDDialogTitle value={value} {...rest} />
    </>
  );
};

DialogTitle.defaultProps = {
  preventModalClose: false,
};

DialogTitle.propTypes = {
  value: PropTypes.string.isRequired,
  preventModalClose: PropTypes.bool,
};
